import current from "./coderconfig.js";
const api = {
    apiBase: current.GetApiBaseUrl(),
    imgBase: current.GetImgBaseUrl(),
    ssqBase: current.GetSsqBaseUrl(),
    main: { //主框架  公用
        login: '/login/doLogin',
        getAllAuMenusByToken: "/menu/getAllAuMenusByToken",
        upload: '/attachment/upload', //上传文件
        download: '/attachment/download', //上传文件
        modifyMobile: "/user/modifyMobile", //5.3.26	修改手机号
        modifyPassword: "/user/modifyPassword" //修改密码

    },
    commonApi: {
        getMobileVerifyCode: "/user/getMobileVerifyCode", //5.3.24	发送手机验证码
        resetPassword: "/user/resetPassword", //5.3.28	重置密码
    },
    //用户管理
    userManager: {
        pageCondition: "/user/pageCondition", //5.3.9	用户管理分页查询条件
        page: "/user/page", //5.3.10	用户管理分页查询
        companyPrivilegePage: "/user/companyPrivilegePage", //5.3.16	公司权限列表分页查询（点击列表的管理公司数量显示管理公司列表也是此接口）
        remove: "/user/remove", //5.3.3	用户删除接口（用于用户管理和用户管理内部权限管理列表删除）
        get: "/user/get", //5.3.8	用户查询接口
        modify: "/user/modify", //5.3.2	用户修改接口
        save: "/user/save", //5.3.1	用户保存接口
        getCompanyListByUserId: "/company/getCompanyListByUserId", //5.3.19	通过用户id查询管理公司
        roleList: "/role/list", //5.4.4	查询角色列表接口
        userExportUser: "/user/exportUser",  //用户管理导出
        userExportUserPrivilege: "/user/exportUserPrivilege"  //用户权限管理导出

    },
    detailUser: {
        userPageCondition: "/user/userPageCondition", //5.3.11	用户明细列表分页查询条件
        userPage: "/user/userPage", //5.3.12	用户明细列表分页查询
        removeByUserCompanyId: "/user/removeByUserCompanyId" //5.3.5	用户公司中间表删除（用于用户管理明细和公司用户列表删除）
    },
    userPermissions: {
        userPrivilegePageCondition: "/user/userPrivilegePageCondition", // 5.3.13	用户公司内部权限管理分页查询条件
        userPrivilegePage: "/user/userPrivilegePage", // 5.3.14	用户公司内部权限管理分页查询
        saveUserCompany: "/user/saveUserCompany", //5.3.19	批量分配公司
        removeJurisdictionById: "/user/removeJurisdictionById", //删除

        getDimensions: "/user/getDimensions", //5.3.20	获取维度
        getDeptInfoForSimpleTree: "/user/getDeptInfoForSimpleTree", //5.3.21	获取权限树
        getPrivilegeDeptsByCustIdToPlugIn: "/user/getPrivilegeDeptsByCustIdToPlugIn", //5.3.22	获取权限树回显
        saveDeptPrivilege: "/user/saveDeptPrivilege", //5.3.23	权限保存
        modifyUser: "/user/modifyUser", //5.3.18	通过用户id修改用户公司内部权限管理处的修改姓名、手机号、管理公司
    },
    companyUser: {
        userCompanyPageCondition: "/user/userCompanyPageCondition", //5.3.15	公司用户分页查询条件
        userCompanyPage: "/user/userCompanyPage", //5.3.16	公司用户分页查询
    },
    //合同
    contract: {
        pageCondition: "/contract/pageCondition", //5.10.1	合同管理查询条件
        page: "/contract/page", //5.10.2	合同管理分页查询
        doLoginToSaas: "/login/doLoginToSaas" //5.2.3	虚拟用户登陆（Ehr代理商平台 -> Ehr Saas平台）
    },

    //权限的菜单
    menuAPI: {
        getList: "/menu/queryAllMenus", //获取权限菜单列表
        addMenu: "/menu/save", //新增保存
        remove: "/menu/remove", //删除
        modify: '/menu/modify', //修改
        uploadIcon: '/attachment/uploadToIcon', //上传图标
    },
    //公司管理
    companyAPI: {
        getList: '/company/page', //获取公司列表数据
        getListSearchKey: '/company/pageConditions', //获取公司列表搜索
        modifyState: '/company/modifyState', //修改公司状态
        companyAdd: '/company/save', //新增公司信息
        companyModify: '/company/modify', //修改公司信息
        companyDel: '/company/remove', //删除公司
    },
    authenSealAPI:{//印章样式
        getList:"/seal/getPage",//获取列表
        SealSave:"/seal/saveSeal",//添加印章样式
        SealModify:"/seal/modifySeal",//修改印章样式
        SealDelete:"/seal/deleteSealById",//删除
        getDetail:"/seal/getCustSealModelDetail",//获取单条印章详情
    },
    //角色管理
    roleAPI: {
        search:"/role/getRolePageCondition",//查询条件接口
        newList:"/role/getRolePage",//新的查询列表
        roleList: '/role/list', //查询列表
        roleAdd: '/role/save', //新增角色
        releDel: '/role/remove', //删除角色
        releGet: '/role/get', //根据id 获取 角色信息
        releSave: '/role/saveRoleMenu', //保存权限
    },
    //法人主体
    legalPersonAPI: {
        legalPersonList: "/custLegal/custLegalPage", //列表查询
        legalPersonSearch: "/custLegal/pageCondition", //查询条件
        getCompanyList: "/custLegal/getCompanyList", //获取用户管理的公司
        getDimensions: "/user/getDimensions", //根据客户id获取纬度
        getDeptInfoForSimpleTree: "/user/getDeptInfoForSimpleTree", //根据客户id和纬度类型获取权限树
        getSsqCertType: "/custLegal/getSsqCertType", //获取法人证件类型
        getInfo: "/custLegal/get", //法人主体信息查询
        save: "/custLegal/save", //法人主体新增保存
        modify: "/custLegal/modify", //法人主体修改保存
        custPageSearch: "/custLegal/custPageCondition", //适用客户列表查询条件
        custPageList: "/custLegal/custPage", //适用客户分页查询
        remove: "/custLegal/remove", //法人主体删除
        authentication: "/custLegal/custLegalSsqAuthentication", //法人电子合同认证
        TaxReturns: "/custLegal/custLegalTaxAuthentication", //报税认证
        getCustRelDeptList: "/custLegal/getApplicationScope", //适用范围查询
        detailedSearch: "/custLegal/legalDetailPageCondition", //法人主体明细查询条件
        detailedList: "/custLegal/legalDetailPage", //法人主体明细分页查询
        getItemTemp: "/contractTemplate/getCustomTemplateFieldLabels", //查看模板对应参数标签
    },
    //模板库相关api
    TemplateLibraryAPI: {
        getTemplateSearch: "/contractTemplate/getTemplateTypePageCondition", //模板类型查询条件
        getTemplateList: "/contractTemplate/getTemplateTypePage", //模板类型库列表查询
        getApplyCustomerSearch: "/contractTemplate/getApplyCustomerPageCondition", //适用客户列表查询条件
        getApplyCustomerList: "/contractTemplate/getApplyCustomerPage", //适用客户列表查询条件
        getCompanyList: "/contractTemplate/getTemplateCompanyList", //获取适用客户 即用户管理的公司
        getTemplateTypeGroup: "/contractTemplate/getTemplateTypeGroup", //获取模板类型分组  --新增和修改的时候用
        getInfo: "/contractTemplate/getTemplateTypeById", //单条查询模板类型信息
        saveTemplateType: "/contractTemplate/saveTemplateType", //编辑保存
        modifyTemplateType: "/contractTemplate/modifyTemplateType", //编辑保存
        remove: "/contractTemplate/removeTemplateTypeById", //删除类型
        getTemplateSetUpSearch: "/contractTemplate/getTemplatePageCondition", //模板查询条件
        getTemplateSetUpList: "/contractTemplate/getTemplatePage", //模板列表查询
        getTempalteForEmpTypes: "/contractTemplate/getTempalteForEmpTypes", //获取模板适用员工类型
        saveTemplate: "/contractTemplate/saveTemplate", //工作证明+合同类型  模板的新增保存
        modifyTemplate: "/contractTemplate/modifyTemplate", //工作证明+合同类型  模板的修改保存
        getTemplateInfo: "/contractTemplate/getTemplateById", //查询工 作证明+合同类型的模板 的数据
        createTemplatePdf: "/contractTemplate/createTemplatePdf", //生成pdf   get 请求
        outPutPdf2Web: "/contractTemplate/outPutPdfToWeb", // 获取pdf 页面
        removeTemp: "/contractTemplate/removeTemplateById", //删除模板
        getTemplateTypeGroups: "/contractTemplate/getTemplateTypeGroups", // 当模板类型分组为合同/协议的时候  获取的类型字典标
        getSealList:"/contractTemplate/getSealList",//获取印章的数组
        getValidityOfContract:"/contractTemplate/getValidityOfContract",//获取合同有效期列表        
    },
    echartAPI:{
        emp:"/company/getCompanyDataBar",
        companies:"/company/getAgentDataBar",
    }
};

//module.exports = api;

export default api;